import {
  INTEREST_GROUPS,
  PRESET_INTEREST_LABELS,
} from "../data/interestGroups.js";

/**
 * Parse `giftee.interests` from Firestore into a Set of trimmed labels.
 */
export function parseInterestsFromGiftee(giftee) {
  const out = new Set();
  if (!giftee) return out;
  if (Array.isArray(giftee.interests)) {
    giftee.interests.forEach((x) => {
      if (typeof x === "string" && x.trim()) out.add(x.trim());
    });
    return out;
  }
  if (typeof giftee.interests === "string") {
    giftee.interests
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((x) => out.add(x));
  }
  return out;
}

/**
 * Labels typed via “Custom interest” only (not in wizard / More sheet catalog).
 * Matches `AddGifteeWizard` InterestsStep `customAdded` logic.
 */
export function customInterestsFromSet(interestSet) {
  return [...interestSet].filter((label) => !PRESET_INTEREST_LABELS.has(label));
}

/**
 * Selected catalog interests in the same order as `INTEREST_GROUPS` (wizard / sheet).
 */
export function orderedSelectedPresetInterests(interestSet) {
  const out = [];
  for (const group of INTEREST_GROUPS) {
    for (const chip of group.chips) {
      if (interestSet.has(chip)) out.push(chip);
    }
  }
  return out;
}
